name: Infrastructure
quadrant: 1
entries:
  - label: MySQL
    ring: adopt
    active: true
    moved: 0
    description: >
      <a href="https://www.mysql.com/">MySQL</a> is an open-source relational
      database management system. Its name is a combination of "My", the name of
      co-founder Michael Widenius's daughter My, and "SQL", the acronym for
      Structured Query Language.

      Teams may adopt PostgreSQL as a robust, open-source relational database
      solution. Its strong ACID compliance, extensibility, and active community
      support make it an excellent choice for building secure and scalable
      applications.
  - label: PostgreSQL
    ring: adopt
    active: true
    moved: 1
    description: >
      <a href="https://www.postgresql.org/">PostgreSQL</a> also known as
      Postgres, is a free and open-source relational database management system
      emphasizing extensibility and SQL compliance.

      In our software products PostgreSQL is kind of new, even though it is
      already a solid component of our software landscape.
  - label: Elasticsearch
    description: >
      <a href="https://www.elastic.co/">Elastic Search</a> is an open source
      search platform. It is an extensible, multi-tenanted, and horizontally
      scalable search solution based on Apache Lucene. It allows complex data
      structures to be indexed and retrieved through a JSON based REST API. It
      provides an elegant model of operation with automatic discovery of peers
      in a cluster, failover, and replication. Elastic Search can be extended
      with a plugin system that allows adding new functionality and changing
      existing behavior. The community around this tool is quite vibrant as
      illustrated by the number of client libraries available in languages like
      Java, C#, Ruby, and JavaScript.

      Elasticsearch is currently on hold as we evaluate open-source alternatives
      like OpenSearch due to recent licensing changes. While Elasticsearch
      continues to serve as our solution for observability (see Kibana) and
      search in existing products, we are assessing whether it remains the best
      fit for our long-term strategy and exploring migration paths to
      open-source alternatives.
    ring: onHold
    active: true
    moved: -1
  - label: MongoDB
    description: >
      For problems that fit the document database model, <a
      href="https://www.mongodb.com/">MongoDB</a> is now the most popular
      choice. In addition to ease of use and a solid technical implementation,
      the community and ecosystem contributed to this success. We are aware of
      problems where teams were tempted by the popularity of MongoDB when a
      document database was not a good fit or they did not understand the
      inherent complexity. When used appropriately, however, MongoDB has proven
      itself on many projects.
    ring: onHold
    active: true
    moved: 0
  - label: DynamoDB
    description: >
      <a href="https://aws.amazon.com/dynamodb/">AWS DynamoDB</a> is a
      serverless, fully managed, distributed NoSQL database with single-digit
      millisecond performance at any scale

      We already use it successfully in some of our production workloads.
    ring: adopt
    active: true
    moved: 1
  - label: AWS Lambda
    description: >
      <a href="https://aws.amazon.com/lambda/">AWS  Lambda</a> is a serverless,
      compute service that runs your code in response to events and
      automatically manages the underlying compute resources for you. These
      events may include changes in state or an update, such as a user placing
      an item in a shopping cart on an ecommerce website.
    ring: adopt
    active: true
    moved: 0
  - label: SQS
    ring: adopt
    active: true
    moved: 0
    description: >
      In our systems, we leverage Amazon SQS (Simple Queue Service) as a
      reliable message queuing service to decouple and scale microservices.  It
      ensures smooth communication between distributed components by managing
      message delivery efficiently.

      SQS also supports various use cases, including event-driven architecture,
      load leveling, and background task processing, making it an integral part
      of our asynchronous workflows.
  - label: SNS
    ring: adopt
    active: true
    moved: 0
    description: >
      In our systems, we utilize Amazon SNS (Simple Notification Service) as a
      scalable and reliable messaging service for pub/sub (publish/subscribe)
      communication. It enables the dissemination of messages to multiple
      subscribers, ensuring real-time updates across distributed systems.

      SNS is particularly useful for event notifications, system alerts, and
      cross-application messaging, allowing us to build highly responsive and
      decoupled architectures.
  - label: AWS S3
    ring: adopt
    active: true
    moved: 0
  - label: Keycloak
    ring: adopt
    active: true
    moved: 0
    link: https://www.keycloak.org/
    description: >
      Keycloak is an open source software product to allow single sign-on with
      identity and access management aimed at modern applications and services.

      We use Keycloak to provide our users with a unified Single Sign-On (SSO)
      environment. This enables us to offer both employees and end users a
      seamless user experience while ensuring security compliance.
  - label: Kubernetes
    ring: onHold
    active: true
    moved: -1
    description: >
      Kubernetes is an open-source container orchestration system for automating
      software deployment, scaling, and management. Originally designed by
      Google, the project is now maintained by a worldwide community of
      contributors, and the trademark is held by the Cloud Native Computing
      Foundation.

      Kubernetes is currently on hold as we evaluate its fit within our
      infrastructure strategy. While it remains in limited internal use for
      developer tools, we are assessing whether it aligns with our long-term
      operational needs and cloud-native architecture.
  - label: Serverless
    description: >
      The Serverless Framework is an open-source tool that simplifies the
      deployment and management of serverless applications, allowing developers
      to build and run applications without managing infrastructure.

      Here's an improved version of that text:

      We are currently evaluating the changes in version 4, specifically
      regarding  the updated pricing model. Due to these adjustments, we believe
      it may no  longer be a sustainable option for our use case. As an
      alternative, we are  exploring CDK to see if it better aligns with our
      needs.
    link: https://www.serverless.com/
    ring: onHold
    active: true
    moved: 0
  - label: CDK
    description: >
      The <a href="https://aws.amazon.com/de/cdk/">AWS Cloud Development Kit
      (CDK)</a> is an open-source framework that enables developers to define
      cloud infrastructure using familiar programming languages.

      It is currently being evaluated as an alternative to the Serverless
      Framework, offering more flexibility and potential alignment with our
      infrastructure needs.
    link: https://aws.amazon.com/de/cdk/
    ring: trial
    active: true
    moved: 0
  - label: ECS
    description: >
      Amazon Elastic Container Service (ECS) is a fully managed container
      orchestration service that helps you to more efficiently deploy, manage,
      and scale containerized applications.

      Our containerized production workloads were migrated from classic data
      centers to ECS wherever possible. With ECS we can run our workloads  at
      scale without bigger changes on the software components. With fargate we
      have a serverless experience that gives our development teams to space to
      focus on developing.
    link: https://aws.amazon.com/de/ecs/
    ring: adopt
    active: true
    moved: 0
  - label: Kibana
    description: >
      When combining modern techniques and architecture styles, such as
      microservices, DevOps and QA in production, development teams need
      increasingly sophisticated monitoring. Simply looking a graphs of disk
      usage and CPU utilization is not sufficient anymore, and many teams
      collect application and business-specific metrics using tools. <a
      href="https://www.elastic.co/kibana/">Kibana</a> is a tools that can help
      with gathering this data and boos observability.

      We use Kibana extensively for our observability needs. It ensures that our
      applications run smoothly even under high-load scenarios. Kibana helps us
      to find issues with our system fast and react accordingly. Based on its
      strengths, Kibana has become our default choice for observing our
      production environments.
    ring: adopt
    active: true
    moved: 0
  - label: Terraform
    description: >
      <a href=" https://www.terraform.io/">Terraform</a> is an open-source
      infrastructure as code tool that allows developers to define and provision
      data center infrastructure using a declarative configuration language. It
      enables consistent and repeatable deployment of cloud and on-premises
      resources, simplifying infrastructure management across multiple
      environments.

      Terraform is widely used to power and manage our infrastructure, ensuring
      consistent and scalable deployment.
    ring: adopt
    active: true
    moved: 0
  - label: ValKey
    description: >
      <a href="https://valkey.io/">ValKey</a> is an innovative key-value store
      designed for high performance and seamless integration with modern
      applications.

      We recommend that teams adopt ValKey instead of Redis. The recent license
      change with Redis has introduced new restrictions that no longer align
      with our operational needs, making ValKey the preferred choice moving
      forward.
    ring: adopt
    active: true
    moved: 2
  - label: AWS Chatbot
    description: >
      <a href="https://aws.amazon.com/de/chatbot/">AWS</a> Chatbot is an
      interactive service that integrates with chat platforms like Slack and
      Amazon Chime, enabling teams to receive and respond to AWS notifications
      and alerts in real time.

      Teams are encouraged to adopt AWS Chatbot as it enhances operational
      responsiveness by bringing AWS insights directly into your daily
      communication channels.
    ring: adopt
    active: true
    moved: 2
  - label: Bref
    description: >
      Bref is a framework that enables PHP applications to run on AWS Lambda,
      streamlining the process of deploying and managing serverless PHP
      applications.

      Currently, the use of Bref is on hold. Although we have some Lambda
      functions built with Bref, for any new projects, especially those
      involving Node.js and TypeScript, those technologies should be preferred
      to align with our modern development practices.
    ring: onHold
    active: true
    moved: -1
  - label: Sentry
    description: >
      <a href="https://sentry.io/">Sentry</a> is an application monitoring and
      error tracking platform that helps developers quickly identify and resolve
      software issues through real-time error monitoring and performance
      tracking.

      We are currently trialing Sentry to evaluate its potential for improving
      our application monitoring, error tracking, and debugging workflows,
      helping teams identify and fix issues faster.
    ring: trial
    active: true
    moved: 2
  - label: OpenSearch
    description: >
      <a href="https://opensearch.org/">OpenSearch</a> is a community-driven,
      Apache 2.0-licensed open source search and analytics suite that provides
      advanced security, alerting, SQL support, and automated index management.

      We are currently trialing OpenSearch as an open-source alternative for
      search and analytics workloads, particularly as we evaluate options beyond
      Elasticsearch given recent licensing changes.
    ring: trial
    active: true
    moved: 2
  - label: Valkey Serverless
    description: >
      <a href="https://aws.amazon.com/elasticache/what-is-valkey/">Valkey
      Serverless</a> is an open-source, in-memory, high-performance key-value
      datastore available on AWS ElastiCache, providing a serverless,
      auto-scaling alternative to Redis with microsecond performance.

      We saw Valkey Serverless as a cost-effective, scalable caching and session
      store solution for our ephemeral,  non-production workloads, but also use
      it in production for some use cases.
    ring: adopt
    active: true
    moved: 2
  - label: AWS AppSync Events
    description: >
      <a href="https://aws.amazon.com/appsync/">AWS AppSync Events</a> is a
      fully managed service that enables developers to create GraphQL APIs by
      connecting to data sources like DynamoDB, Lambda, and more, with built-in
      real-time capabilities and robust security features.

      We are using AWS AppSync Events with success on production workload and
      see its potential for building flexible, scalable Websocket APIs with
      real-time capabilities and simplified data integration across multiple
      sources.
    ring: adopt
    active: true
    moved: 1
  - label: AWS Bedrock
    description: >
      <a href="https://aws.amazon.com/bedrock/">AWS Bedrock</a> is a
      comprehensive, secure, and flexible service for building generative AI
      applications and agents, providing access to foundation models, tools for
      customization, safety guardrails, and cost optimization.

      We are currently implement first services using AWS Bedrock to evaluate
      its potential for building and deploying generative AI applications,
      leveraging foundation models while maintaining security and compliance
      standards.
    ring: trial
    active: true
    moved: 1
